import ValueObject from "../../../../../frontend/ValueObject";

export interface ITagCloudFilter {
    identifier: string,
    view: string,
    label: string,
    color: string,
    image_url: string,
    state: 'active' | 'default';
}
export default class TagCloudFilter<T extends ITagCloudFilter> extends ValueObject<T> {
    static fromApi( props: any ) {
        return new TagCloudFilter( props );
    }

    public get identifier(): string {
        return this._props.identifier;
    }

    public get state(): 'active' | 'default' {
        return this._props.state;
    }
    public set state(value: 'active' | 'default') {
        this._props.state = value;
    }
    public get view(): string {
        return this._props.view;
    }

    public get label(): string {
        return this._props.label;
    }

    public get image_url(): string {
        return this._props.image_url;
    }

    public get color(): string {
        return this._props.color;
    }
}
